module.exports = __webpack_public_path__ + "static/img/web_banner002.42abcd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/web_banner002.jpg
// module id = QlAe
// module chunks = 15